import { StatsValue } from "@/types"


export const consumptionTrendFormattedMock = {
  analytics: {
    overall: {
      trend_message: "The total consumption shows a normal trend over the past 1 year.",
      high_consumption_message: "March 2024 and January 2024 emerge as periods of high consumption over the past 1 year."
    }
  },
  data: [
    // Year 2024 - from jan to dec 2024
    { "time": "2024-01-31", "Residential": 20000, "CommercialA": 15000, "CommercialB": 15000, "Government": 12000 },
    { "time": "2024-02-29", "Residential": 1500, "CommercialA": 12000, "CommercialB": 18000, "Government": 15000 },
    { "time": "2024-03-31", "Residential": 1800, "CommercialA": 10000, "CommercialB": 12000, "Government": 10000 },
    { "time": "2024-04-30", "Residential": 1200, "CommercialA": 8000, "CommercialB": 20000, "Government": 18000 },
    { "time": "2024-05-31", "Residential": 2100, "CommercialA": 5000, "CommercialB": 25000, "Government": 13000 },
    { "time": "2024-06-30", "Residential": 2500, "CommercialA": 6000, "CommercialB": 17000, "Government": 9000 },
    { "time": "2024-07-31", "Residential": 3000, "CommercialA": 4000, "CommercialB": 22000, "Government": 20000 },
    { "time": "2024-08-31", "Residential": 3500, "CommercialA": 7000, "CommercialB": 19000, "Government": 25000 },
    { "time": "2024-09-30", "Residential": 2000, "CommercialA": 8500, "CommercialB": 21000, "Government": 14000 },
    { "time": "2024-10-31", "Residential": 4200, "CommercialA": 9200, "CommercialB": 24000, "Government": 22000 },
    { "time": "2024-11-30", "Residential": 5000, "CommercialA": 7500, "CommercialB": 16000, "Government": 16000 },
    { "time": "2024-12-31", "Residential": 4600, "CommercialA": 6400, "CommercialB": 18000, "Government": 17000 },

    // Year 2025 - from jan to dec 2025
    { "time": "2025-01-31", "Residential": 3800, "CommercialA": 9000, "CommercialB": 15000, "Government": 19000 },
    { "time": "2025-02-28", "Residential": 3000, "CommercialA": 10200, "CommercialB": 20000, "Government": 13000 },
    { "time": "2025-03-31", "Residential": 4100, "CommercialA": 9500, "CommercialB": 25000, "Government": 21000 },
    { "time": "2025-04-30", "Residential": 540, "CommercialA": 6000, "CommercialB": 23000, "Government": 24000 },
    { "time": "2025-05-31", "Residential": 2800, "CommercialA": 10800, "CommercialB": 10800, "Government": 16000 },
    { "time": "2025-06-30", "Residential": 3200, "CommercialA": 7450, "CommercialB": 7450, "Government": 19000 },
    { "time": "2025-07-31", "Residential": 2100, "CommercialA": 3200, "CommercialB": 3200, "Government": 23000 },
    { "time": "2025-08-31", "Residential": 1500, "CommercialA": 5800, "CommercialB": 19000, "Government": 22000 },
    { "time": "2025-09-30", "Residential": 1100, "CommercialA": 6700, "CommercialB": 16000, "Government": 21000 },
    { "time": "2025-10-31", "Residential": 1200, "CommercialA": 7200, "CommercialB": 22000, "Government": 20000 },
    { "time": "2025-11-30", "Residential": 1300, "CommercialA": 8100, "CommercialB": 17000, "Government": 21000 },
    { "time": "2025-12-31", "Residential": 1400, "CommercialA": 7300, "CommercialB": 25000, "Government": 25000 }

  ]
}
export const consumptionTrendMock = {
  Residential: [
    { time: "2024-01-31", total_consumption: 20000 },
    { time: "2024-02-29", total_consumption: 1500 },
    { time: "2024-03-31", total_consumption: 1800 },
    { time: "2024-04-30", total_consumption: 1200 },
    { time: "2024-05-31", total_consumption: 2100 },
    { time: "2024-06-30", total_consumption: 2500 },
    { time: "2024-07-31", total_consumption: 3000 },
    { time: "2024-08-31", total_consumption: 3500 },
    { time: "2024-09-30", total_consumption: 2000 },
    { time: "2024-10-31", total_consumption: 4200 },
    { time: "2024-11-30", total_consumption: 5000 },
    { time: "2024-12-31", total_consumption: 4600 },
    { time: "2025-01-31", total_consumption: 3800 },
    { time: "2025-02-28", total_consumption: 3000 },
    { time: "2025-03-31", total_consumption: 4100 },
    { time: "2025-04-30", total_consumption: 540 },
    { time: "2025-05-31", total_consumption: 2800 },
    { time: "2025-06-30", total_consumption: 3200 },
    { time: "2025-07-31", total_consumption: 2100 },
    { time: "2025-08-31", total_consumption: 1500 },
    { time: "2025-09-30", total_consumption: 1100 },
    { time: "2025-10-31", total_consumption: 1200 },
    { time: "2025-11-30", total_consumption: 1300 },
    { time: "2025-12-31", total_consumption: 1400 }
  ]
  ,
  CommercialA: [
    { time: "2024-01-31", total_consumption: 15000 },
    { time: "2024-02-29", total_consumption: 12000 },
    { time: "2024-03-31", total_consumption: 10000.0 },
    { time: "2024-04-30", total_consumption: 8000 },
    { time: "2024-05-31", total_consumption: 5000 },
    { time: "2024-06-30", total_consumption: 6000 },
    { time: "2024-07-31", total_consumption: 4000 },
    { time: "2024-08-31", total_consumption: 7000 },
    { time: "2024-09-30", total_consumption: 8500 },
    { time: "2024-10-31", total_consumption: 9200 },
    { time: "2024-11-30", total_consumption: 7500 },
    { time: "2024-12-31", total_consumption: 6400 },
    { time: "2025-01-31", total_consumption: 9000 },
    { time: "2025-02-28", total_consumption: 10200 },
    { time: "2025-03-31", total_consumption: 9500 },
    { time: "2025-04-30", total_consumption: 6000 },
    { time: "2025-05-31", total_consumption: 10800 },
    { time: "2025-06-30", total_consumption: 7450 },
    { time: "2025-07-31", total_consumption: 3200 },
    { time: "2025-08-31", total_consumption: 5800 },
    { time: "2025-09-30", total_consumption: 6700 },
    { time: "2025-10-31", total_consumption: 7200 },
    { time: "2025-11-30", total_consumption: 8100 },
    { time: "2025-12-31", total_consumption: 7300 },
  ],
  CommercialB: [
    { time: "2024-01-31", total_consumption: 15000 },
    { time: "2024-02-29", total_consumption: 18000 },
    { time: "2024-03-31", total_consumption: 12000 },
    { time: "2024-04-30", total_consumption: 20000 },
    { time: "2024-05-31", total_consumption: 25000 },
    { time: "2024-06-30", total_consumption: 17000 },
    { time: "2024-07-31", total_consumption: 22000 },
    { time: "2024-08-31", total_consumption: 19000 },
    { time: "2024-09-30", total_consumption: 21000 },
    { time: "2024-10-31", total_consumption: 24000 },
    { time: "2024-11-30", total_consumption: 16000 },
    { time: "2024-12-31", total_consumption: 18000 },
    { time: "2025-01-31", total_consumption: 15000 },
    { time: "2025-02-28", total_consumption: 20000 },
    { time: "2025-03-31", total_consumption: 25000 },
    { time: "2025-04-30", total_consumption: 23000 },
    { time: "2025-05-31", total_consumption: 10800 },
    { time: "2025-06-30", total_consumption: 7450 },
    { time: "2025-07-31", total_consumption: 3200 },
    { time: "2025-08-31", total_consumption: 19000 },
    { time: "2025-09-30", total_consumption: 16000 },
    { time: "2025-10-31", total_consumption: 22000 },
    { time: "2025-11-30", total_consumption: 17000 },
    { time: "2025-12-31", total_consumption: 25000 },
  ]
  ,
  Government: [
    { time: "2024-01-31", total_consumption: 12000 },
    { time: "2024-02-29", total_consumption: 15000 },
    { time: "2024-03-31", total_consumption: 10000 },
    { time: "2024-04-30", total_consumption: 18000 },
    { time: "2024-05-31", total_consumption: 13000 },
    { time: "2024-06-30", total_consumption: 9000 },
    { time: "2024-07-31", total_consumption: 20000 },
    { time: "2024-08-31", total_consumption: 25000 },
    { time: "2024-09-30", total_consumption: 14000 },
    { time: "2024-10-31", total_consumption: 22000 },
    { time: "2024-11-30", total_consumption: 16000 },
    { time: "2024-12-31", total_consumption: 17000 },
    { time: "2025-01-31", total_consumption: 19000 },
    { time: "2025-02-28", total_consumption: 13000 },
    { time: "2025-03-31", total_consumption: 21000 },
    { time: "2025-04-30", total_consumption: 24000 },
    { time: "2025-05-31", total_consumption: 16000 },
    { time: "2025-06-30", total_consumption: 19000 },
    { time: "2025-07-31", total_consumption: 23000 },
    { time: "2025-08-31", total_consumption: 22000 },
    { time: "2025-09-30", total_consumption: 21000 },
    { time: "2025-10-31", total_consumption: 20000 },
    { time: "2025-11-30", total_consumption: 21000 },
    { time: "2025-12-31", total_consumption: 25000 }
  ]

}


//this mockdata is based on api data.
export const anualRevenueMockData = {
  interpretation: "53.57% of annual revenue comes from Government SCs.",
  highest: {
    connection_type: "Government",
    total_amount: 600.0,
    percentage: 53.57142857142857,
  },
  data: [
    {
      connection_type: "Government",
      total_amount: 600.0,
      percentage: 53.57142857142857,
    },
    {
      connection_type: "Residential",
      total_amount: 520.0,
      percentage: 46.42857142857143,
    },
    {
      connection_type: "Commercial",
      total_amount: 520.0,
      percentage: 46.42857142857143,
    },
  ],
}

export const revenueBarGraphData = {
  total_annual_revenue: 1120.0,
  interpretation: "The top 10 consumers generate 100.0% of annual revenue.",

  data: [
    {
      account: "DWD-400036",
      connection_type: "Residential",
      amount: 520.0,
    },
    {
      account: "DCWD-400039",
      connection_type: "Government",
      amount: 600.0,
    },
    {
      account: "DCWD-400040",
      connection_type: "Commercial",
      amount: 10.0,
    },
  ],
}

export const consumerClassMockData = [
  {
    consumer_class: "Commercial A",
    total_current_consumption: 34.0,
    percentage: 20.0,
  },
  {
    consumer_class: "Commercial B",
    total_current_consumption: 30.0,
    percentage: 0.0,
  },
  {
    consumer_class: "Government",
    total_current_consumption: 0.0,
    percentage: 20.0,
  },
  {
    consumer_class: "Residential",
    total_current_consumption: 100.0,
    percentage: 100.0,
  },
  {
    consumer_class: "Government A",
    total_current_consumption: 50.0,
    percentage: 0.0,
  },
  {
    consumer_class: "Test Type",
    total_current_consumption: 0.0,
    percentage: 0.0,
  },
]

export const mockStatsCardData: Record<string, StatsValue> = {
  annual_revenue: { total: 176000000, percentage: 12.5, status: "Increased" },
  government_consumers: { total: 320, percentage: 3.1, status: "Stable" },
  commercial_a_consumers: {
    total: 150,
    percentage: -1.2,
    status: "Decreased",
  },
  commercial_b_consumers: {
    total: 90,
    percentage: 0.5,
    status: "Slightly Up",
  },
  residential_consumers: {
    total: 5400,
    percentage: 5.6,
    status: "Increased",
  },
  hydrant_consumers: { total: 12, percentage: 0.0, status: "No Change" },
}

export const docsRequirements = [
  { value: "notarized_deed_of_sale", label: "Notarized Deed of Sale" },
  { value: "notarized_transfer_of_rights", label: "Notarized Transfer of Rights" },
  { value: "tax_declaration", label: "Tax Declaration" },
  { value: "certificate_of_occupancy", label: "Certificate of Occupancy" },
  { value: "building_permit", label: "Building Permit" }, // fixed typo from "oBuilding Permit"
  { value: "land_title", label: "Land Title" },
  { value: "notarized_spa", label: "Notarized Special Power of Attorney" },
];

export const validIds = [
  { value: "post_office_id", label: "Post Office ID" },
  { value: "gsis_id", label: "GSIS ID" },
  { value: "sss_id", label: "SSS ID" },
  { value: "dfa_id", label: "DFA ID" },
  { value: "phic_id", label: "PHIC ID" },
  { value: "bir_id", label: "BIR ID" },
  { value: "lto_id", label: "LTO ID" },
  { value: "comelec_id", label: "COMELEC ID" },
  { value: "company_id", label: "Company ID" },
  { value: "school_id", label: "School ID" },
];
